export type Post = {
  _id: string;
  title: string;
  slug: string; // GROQ returns slug.current as "slug"
  date?: string;
  coverImage?: any;
  author?: { name?: string } | null;
  tags?: string[];
};

// ✅ extended pill set to match your top bar
export type Category =
  | "All"
  | "AI"
  | "Product"
  | "Blogs"
  | "News"
  | "Customer Gallery"
  | "News & Blogs"; // ← NEW: understand the combined pill too

// lowercase tags for matching
export const TAGS = {
  ai: ["ai"],
  product: ["product"],
  blogs: ["blog", "blogs"],
  news: ["news"],
  customer: ["case-study", "case study"],
};

// union used by "News & Blogs"
export const NEWS_BLOGS_UNION = [
  ...TAGS.ai,
  ...TAGS.product,
  ...TAGS.news,
  ...TAGS.blogs,
];
